import { render, staticRenderFns } from "./ComprometimentosDash.vue?vue&type=template&id=59ff759a"
import script from "./ComprometimentosDash.vue?vue&type=script&lang=js"
export * from "./ComprometimentosDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports